import { Group } from '@ekhodealer/ekho-common/rev';

import { StatBox } from '@common/components/StatBox';
import { formatCurrency } from '@common/lib/currency';
import { PLACEHOLDER } from '@common/lib/strings';

import { useGetPreorderStats } from '../api/useGetPreorderStats';

function formatAvgTimePendingInvitation(weeks: number | null | undefined): string {
	if (weeks == null) return '\u2014';
	if (weeks === 0) return '< 1 week';
	if (weeks === 1) return '1 week';
	return `${weeks} weeks`;
}

export function PreorderStats() {
	const { data: stats, isLoading } = useGetPreorderStats();

	// Use placeholder if loading
	const placeholder = isLoading ? PLACEHOLDER : undefined;

	return (
		<Group itemsSpacing='16' noWrap itemsAlignX='stretch'>
			<StatBox
				title='Total preorder value'
				detail={formatCurrency(stats?.totalPreorderValue, placeholder, false)}
			/>
			<StatBox
				title='Avg time pending invitation'
				detail={placeholder ?? formatAvgTimePendingInvitation(stats?.avgTimePendingInvitationWeeks)}
				tooltip='Average time preorders spend in Pending Invitation status before being converted or moving to next stage'
			/>
			<StatBox
				title='Total active preorders'
				detail={placeholder ?? String(stats?.totalActivePreorders ?? 0)}
			/>
			<StatBox
				title='Est. active pipeline value'
				detail={formatCurrency(stats?.estimatedTotalValue, placeholder, false)}
			/>
		</Group>
	);
}
